import { getNoStatusesOptions } from './getNoStatusesOptions';
import { getSingleAccountOptions } from './getSingleAccountOptions';
import { getMultipleAccountOptions } from './getMultipleAccountsOptions';
export const getOptions = ({
  accountStatusesList = [],
  alertStore,
  loading,
  showInstalledStatus,
  onAuthSucceeded = () => {},
  productType,
  setPopoverOpen,
  tracker
}) => {
  if ((accountStatusesList === null || accountStatusesList === void 0 ? void 0 : accountStatusesList.length) === 0) {
    return getNoStatusesOptions({
      showInstalledStatus,
      productType
    });
  }
  if (accountStatusesList.length === 1) {
    return getSingleAccountOptions({
      alertStore,
      loading,
      onAuthSucceeded,
      setPopoverOpen,
      statusData: accountStatusesList[0],
      tracker
    });
  }
  return getMultipleAccountOptions({
    accountStatusesList,
    tracker
  });
};